import React from 'react';
import RestaurantCard from '../molecule/RestaurantCard';
import { Box, Container, Flex, Link } from '@chakra-ui/react';
import HoverBar from '../organism/HoverBar';
import { Restaurant, ResultProps } from '../../../type';
import RestaurantHeader from '../organism/RestaurantHeader';
import { restaurants } from '../../../constants/restaurant';
import HomeButtonSection from '../../common/organism/HomeButtonSection';
import useWindowDimensions from '../../../hooks/windowDimensions';

export const RestaurantTemplate: React.FC<ResultProps> = ({ food }: ResultProps) => {
  const resultRestaurants = Object.values<Restaurant>(restaurants).filter((it) => it.foods.includes(food));
  const dimensions = useWindowDimensions();
  return (
    <Container minHeight={dimensions.height} pb={8}>
      <HomeButtonSection />
      <RestaurantHeader count={resultRestaurants.length} />
      <Flex direction='column' align='center' justify='start'>
        {resultRestaurants.map((it, key) => (
          <RestaurantCard key={key} food={food} restaurant={it} width='100%' />
        ))}
      </Flex>
      <Box width='100%' align='center'>
        <Link tabIndex={0} href='https://forms.gle/NkPfTpvqPiF9VPcZ9' isExternal>
          건의할 것이 있나요?(추가/수정)
        </Link>
      </Box>
      <HoverBar />
    </Container>
  );
};

export default RestaurantTemplate;
